import Default from './default';
import Primary from './primary';
import Secondary from './secondary';

const Table = {
  Default,
  Primary,
  Secondary,
};

export default Table;
